import BankAccountsDetailContainer from "containers/panel/admin/bank-accounts-detail-container";

const BankAccountsDetailPage = () => {
  return (
    <BankAccountsDetailContainer />
  )
}

export default BankAccountsDetailPage;
